<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="配送类型" prop="dvyType">
        <a-select
          show-search
          v-model="form.dvyType"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option :value="1">快递</a-select-option>
          <a-select-option :value="2">自提</a-select-option>
          <a-select-option :value="3">无需快递</a-select-option>
          <a-select-option :value="4">同城配送</a-select-option>
          <!-- <a-select-option v-for="d in evaluationOptions" :key="d.value">{{ d.label }}</a-select-option> -->
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="物流单号" prop="dvyFlowId" v-if="form.dvyType == 1 || form.dvyType == 4">
        <a-input v-model="form.dvyFlowId" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="运费" prop="freightAmount" v-if="form.dvyType == 1 || form.dvyType == 4">
        <a-input v-model="form.freightAmount" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/pressure/integralOrder'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      showLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        dvyFlowId: undefined,
        dvyType: 1,
        freightAmount: undefined,
      },
      isShow: false,
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      inputVisible: false,
      inputVisibles: false,
      rules: {
        categoryName: [{ required: true, message: '请输入的分类名称', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        optionalUnit: [{ required: true, message: '请添加单位', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
        const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info5555', info)
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        dvyFlowId: undefined,
        dvyType: 1,
        freightAmount: undefined,
      }
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加商品分类'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      // this.reset()
      const postId = row ? row.id : ids

      getObj(postId).then((response) => {
        console.log(response, 'responseresponse')
        this.form = {
          id: response.data.id,
          dvyFlowId: undefined,
          dvyType: 1,
          freightAmount: undefined,
        }
        this.open = true
        this.formTitle = '发货'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
           this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            const query = {
              dvyFlowId: this.form.dvyFlowId,
              id: this.form.id,
              freightAmount: this.form.freightAmount,
              dvyType: this.form.dvyType,
            }
            putObj(query)
              .then((response) => {
                this.$message.success('发货成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
           const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
